import { User } from 'oidc-client-ts';

let getAccessTokenSilently: () => Promise<string>;

export const securityClient = {
  getAccessTokenSilently: () => getAccessTokenSilently?.() ?? Promise.resolve(''),
  setAccessTokenSilently: (func: () => Promise<string>) =>
    (getAccessTokenSilently = func),
  clearToken: () => {
    getAccessTokenSilently = async () => '';
  },
};